(() => {
  const money = (cents, format) => {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents, format);
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format((Number(cents) || 0) / 100);
  };

  const publishCart = (cart) => {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
    if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'pestdeny-dtc', cartData: cart });
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  };

  document.querySelectorAll('[data-pd-hero]').forEach((root) => {
    const main = root.querySelector('[data-pd-main-image]');
    root.querySelectorAll('[data-pd-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
      root.querySelectorAll('[data-pd-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (main && thumb.dataset.image) {
        main.src = thumb.dataset.image;
        main.srcset = '';
        main.alt = thumb.dataset.alt || '';
      }
    }));

    const variantInput = root.querySelector('[data-pd-variant]');
    const quantityInput = root.querySelector('[data-pd-quantity]');
    const price = root.querySelector('[data-pd-price]');
    const compare = root.querySelector('[data-pd-compare]');
    const offers = [...root.querySelectorAll('[data-pd-offer]')];
    const selectOffer = (offer) => {
      offers.forEach((item) => {
        const active = item === offer;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (variantInput) variantInput.value = offer.dataset.variant || variantInput.value;
      if (quantityInput) quantityInput.value = Math.max(1, Number(offer.dataset.quantity || 1));
      if (price) price.textContent = offer.dataset.priceLabel || money(offer.dataset.price, root.dataset.moneyFormat);
      if (compare) {
        compare.textContent = offer.dataset.compareLabel || (Number(offer.dataset.compare) > Number(offer.dataset.price) ? money(offer.dataset.compare, root.dataset.moneyFormat) : '');
        compare.hidden = !compare.textContent;
      }
      const submitButton = root.querySelector('[data-pd-form] button[type="submit"]');
      const variantAvailable = offer.dataset.variantAvailable !== 'false';
      if (submitButton) submitButton.disabled = !variantAvailable;
      document.dispatchEvent(new CustomEvent('pestdeny:offer', { detail: { variantId: variantInput?.value, quantity: quantityInput?.value, price: price?.textContent, compare: compare?.textContent } }));
    };
    offers.forEach((offer) => offer.addEventListener('click', () => selectOffer(offer)));
    const initial = offers.find((item) => item.classList.contains('is-selected')) || offers[0];
    if (initial) selectOffer(initial);

    const form = root.querySelector('[data-pd-form]');
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (!variantInput?.value || !button) return;
      button.disabled = true;
      button.classList.add('is-loading');
      try {
        const cartUi = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sectionIds = cartUi?.getSectionsToRender
          ? cartUi.getSectionsToRender().map((section) => section.id)
          : [];

        const formData = new FormData(form);
        formData.set('id', String(variantInput.value));
        formData.set('quantity', String(Math.max(1, Number(quantityInput?.value || 1))));
        if (sectionIds.length) {
          formData.set('sections', sectionIds.join(','));
          formData.set('sections_url', window.location.pathname);
          cartUi.setActiveElement?.(document.activeElement);
        }

        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        const added = await response.json();
        if (!response.ok || added.status) throw new Error(added.description || added.message || 'Unable to add this offer.');

        // Dawn keeps an `is-empty` class on <cart-drawer> when the drawer was empty on page load.
        // Remove it before rendering the returned sections, otherwise the newly-added items exist in Shopify
        // but the drawer can still display its empty state.
        if (cartUi) {
          cartUi.classList.remove('is-empty');
          cartUi.querySelector?.('.drawer__inner')?.classList.remove('is-empty');
          if (cartUi.renderContents && added.sections) cartUi.renderContents(added);
        }

        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = cartResponse.ok ? await cartResponse.json() : added;
        publishCart(cart);
      } catch (error) {
        console.error('[PESTDENY quantity add]', error);
        window.alert(error.message);
      } finally {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    });

  });

  document.querySelectorAll('[data-pd-reviews]').forEach((root) => {
    const cards = [...root.querySelectorAll('[data-pd-review]')];
    const step = Number(root.dataset.step || 8);
    let limit = Number(root.dataset.initial || step);
    let filter = 'all';
    const counter = root.querySelector('[data-pd-review-count]');
    const load = root.querySelector('[data-pd-load]');
    const matches = (card) => filter === 'all' || card.dataset.rating === filter || (card.dataset.category || '').split(',').includes(filter);
    const render = () => {
      const filtered = cards.filter(matches);
      cards.forEach((card) => { card.hidden = true; });
      filtered.slice(0, limit).forEach((card) => { card.hidden = false; });
      if (counter) counter.textContent = Math.min(limit, filtered.length);
      if (load) load.hidden = limit >= filtered.length;
    };
    root.querySelectorAll('[data-pd-filter]').forEach((button) => button.addEventListener('click', () => {
      root.querySelectorAll('[data-pd-filter]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
      filter = button.dataset.pdFilter;
      limit = Number(root.dataset.initial || step);
      render();
    }));
    load?.addEventListener('click', () => { limit += step; render(); });
    render();
  });

  const pdAnchorSlug = (value = '') => String(value)
    .trim()
    .replace(/^#/, '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const pdResolveAnchor = (hash) => {
    const raw = decodeURIComponent(String(hash || '').replace(/^#/, '')).trim();
    const slug = pdAnchorSlug(raw);
    if (!slug) return null;
    const exact = document.getElementById(raw) || document.getElementById(slug);
    if (exact) return exact;
    const aliases = {
      'product': '[data-pd-hero]', 'product-hero': '[data-pd-hero]', 'hero': '[data-pd-hero]',
      'bundles': '[data-pd-offers]', 'offers': '[data-pd-offers]',
      'technology': '.pd-targets', 'science': '.pd-targets', 'what-it-stops': '.pd-targets', 'targets': '.pd-targets',
      'how-it-works': '.pd-how', 'how': '.pd-how', 'works': '.pd-how',
      'comparison': '.pd-comparison', 'compare': '.pd-comparison', 'comparison-table': '.pd-comparison',
      'reviews': '[data-pd-reviews]', 'review': '[data-pd-reviews]', 'review-engine': '[data-pd-reviews]', 'testimonials': '[data-pd-reviews]',
      'guarantee': '.pd-guarantee', 'warranty': '.pd-guarantee',
      'safety': '.pd-safety',
      'timeline': '.pd-timeline',
      'shop': '.pd-final', 'final-cta': '.pd-final'
    };
    return document.querySelector(aliases[slug] || `[data-pd-anchor="${CSS.escape(slug)}"]`);
  };

  const pdScrollToAnchor = (target, slug) => {
    const header = document.querySelector('.section-header');
    const headerHeight = header ? Math.max(0, header.getBoundingClientRect().height) : 0;
    const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerHeight - 12);
    window.scrollTo({ top, behavior: 'smooth' });
    if (slug && window.history?.replaceState) window.history.replaceState(null, '', `#${slug}`);
  };

  const pdCloseMobileDrawerCleanly = (drawer) => {
    if (!drawer) return;
    const details = drawer.querySelector('details');
    const summary = details?.querySelector(':scope > summary') || drawer.querySelector('summary');
    details?.classList.remove('menu-opening');
    details?.removeAttribute('open');
    summary?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile', 'overflow-hidden');
    document.querySelector('.section-header')?.classList.remove('menu-open');
    if (typeof removeTrapFocus === 'function') {
      try { removeTrapFocus(summary || null); } catch (_) { /* no-op */ }
    }
  };

  document.querySelectorAll('.pd-header-nav__link[href^="#"], .pd-mobile-menu__card[href^="#"], .pd-mobile-menu__cta[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href') || '';
      const slug = pdAnchorSlug(href);
      const target = pdResolveAnchor(href);
      const drawer = link.closest('header-drawer');

      if (target) {
        event.preventDefault();
        if (drawer) pdCloseMobileDrawerCleanly(drawer);
        window.requestAnimationFrame(() => pdScrollToAnchor(target, slug));
        return;
      }

      // The same menu can be used from any Shopify page. If the requested section
      // is not on the current page, route to the PestDeny product page + its anchor.
      if (slug) {
        event.preventDefault();
        if (drawer) pdCloseMobileDrawerCleanly(drawer);
        const productUrl = document.querySelector('.pd-mobile-drawer')?.dataset.pdProductUrl || '/products/pestdeny-ultrasonic-pest-defense-system';
        window.location.assign(`${productUrl}#${slug}`);
      }
    });
  });

  // When arriving from another page with #how-it-works, #reviews, etc., account for
  // the sticky header instead of letting the browser leave the heading underneath it.
  const pdScrollFromLocationHash = () => {
    if (!window.location.hash) return;
    const slug = pdAnchorSlug(window.location.hash);
    const target = pdResolveAnchor(window.location.hash);
    if (!target) return;
    window.setTimeout(() => pdScrollToAnchor(target, slug), 120);
  };
  if (document.readyState === 'complete') pdScrollFromLocationHash();
  else window.addEventListener('load', pdScrollFromLocationHash, { once: true });

  document.querySelectorAll('[data-pd-scroll-offers]').forEach((button) => button.addEventListener('click', () => {
    const target = document.querySelector(button.dataset.pdScrollOffers || '[data-pd-offers]');
    target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }));

  document.querySelectorAll('[data-pd-countdown]').forEach((timer) => {
    const output = timer.querySelector('[data-pd-timer]');
    const duration = Math.max(2, Number(timer.dataset.minutes || 15)) * 60 * 1000;
    const storageKey = timer.dataset.storageKey || 'pd-offer-timer';
    const readExpiry = () => {
      try { return Number(window.sessionStorage.getItem(storageKey) || 0); } catch (_) { return 0; }
    };
    const saveExpiry = (value) => {
      try { window.sessionStorage.setItem(storageKey, String(value)); } catch (_) { /* Timer still works in memory. */ }
    };
    let expiresAt = readExpiry();
    if (!expiresAt || expiresAt <= Date.now()) {
      expiresAt = Date.now() + duration;
      saveExpiry(expiresAt);
    }
    const render = () => {
      let remaining = Math.max(0, Math.floor((expiresAt - Date.now()) / 1000));
      if (remaining <= 0) {
        expiresAt = Date.now() + duration;
        saveExpiry(expiresAt);
        remaining = Math.floor(duration / 1000);
      }
      const hours = String(Math.floor(remaining / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
      const seconds = String(remaining % 60).padStart(2, '0');
      if (output) output.textContent = `${hours}:${minutes}:${seconds}`;
    };
    render();
    window.setInterval(render, 1000);
  });

  document.querySelectorAll('[data-pd-science-root]').forEach((root) => {
    const modal = root.querySelector('[data-pd-science-modal]');
    if (!modal) return;
    const openModal = () => typeof modal.showModal === 'function' ? modal.showModal() : modal.setAttribute('open', '');
    const closeModal = () => typeof modal.close === 'function' ? modal.close() : modal.removeAttribute('open');
    root.querySelector('[data-pd-science-open]')?.addEventListener('click', openModal);
    root.querySelector('[data-pd-science-close]')?.addEventListener('click', closeModal);
    modal.addEventListener('click', (event) => { if (event.target === modal) closeModal(); });
    root.querySelector('[data-pd-science-cta]')?.addEventListener('click', () => {
      closeModal();
      document.querySelector('[data-pd-offers]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  document.addEventListener('pestdeny:offer', (event) => {
    document.querySelectorAll('[data-pd-sticky-variant]').forEach((input) => { input.value = event.detail.variantId; });
    document.querySelectorAll('[data-pd-sticky-quantity]').forEach((input) => { input.value = event.detail.quantity; });
    document.querySelectorAll('[data-pd-sticky-price]').forEach((item) => { item.textContent = event.detail.price; });
    document.querySelectorAll('[data-pd-sticky-compare]').forEach((item) => {
      item.textContent = event.detail.compare || '';
      item.hidden = !event.detail.compare;
    });
  });

  document.querySelectorAll('[data-pd-sticky]').forEach((bar) => {
    const hero = document.querySelector('[data-pd-hero]');
    const trigger = hero?.querySelector('[data-pd-form]');
    const activeOffer = hero?.querySelector('[data-pd-offer].is-selected');
    if (activeOffer) {
      const stickyCompare = bar.querySelector('[data-pd-sticky-compare]');
      bar.querySelector('[data-pd-sticky-variant]').value = activeOffer.dataset.variant || '';
      bar.querySelector('[data-pd-sticky-quantity]').value = activeOffer.dataset.quantity || 1;
      bar.querySelector('[data-pd-sticky-price]').textContent = activeOffer.dataset.priceLabel || money(activeOffer.dataset.price, hero.dataset.moneyFormat);
      if (stickyCompare) {
        stickyCompare.textContent = activeOffer.dataset.compareLabel || '';
        stickyCompare.hidden = !stickyCompare.textContent;
      }
    }
    const triggerMode = bar.dataset.pdStickyTrigger || 'hero_button';
    const triggerOffset = Number(bar.dataset.pdStickyOffset || 80);
    const heroButton = hero?.querySelector('[data-pd-form] button[type="submit"]');
    const anchorId = (bar.dataset.pdStickyAnchor || '').replace(/^#/, '').trim();
    const sectionTrigger = anchorId ? document.getElementById(anchorId) : null;

    const updateStickyVisibility = () => {
      let visible = false;
      if (triggerMode === 'always') {
        visible = true;
      } else if (triggerMode === 'hero_section') {
        visible = Boolean(hero && hero.getBoundingClientRect().bottom <= triggerOffset);
      } else if (triggerMode === 'section') {
        visible = Boolean(sectionTrigger && sectionTrigger.getBoundingClientRect().top <= triggerOffset);
      } else {
        visible = Boolean(heroButton && heroButton.getBoundingClientRect().bottom <= triggerOffset);
      }
      bar.classList.toggle('is-visible', visible);
    };

    let stickyTicking = false;
    const requestStickyUpdate = () => {
      if (stickyTicking) return;
      stickyTicking = true;
      window.requestAnimationFrame(() => {
        updateStickyVisibility();
        stickyTicking = false;
      });
    };
    updateStickyVisibility();
    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', requestStickyUpdate, { passive: true });

    bar.querySelector('[data-pd-sticky-submit]')?.addEventListener('click', () => {
      const action = bar.dataset.pdStickyAction || 'add_to_cart';
      if (action === 'scroll') {
        let slug = (bar.dataset.pdStickyClickTarget || 'bundles').trim();
        if (slug === 'custom') slug = pdAnchorSlug(bar.dataset.pdStickyCustomAnchor || 'bundles');
        const target = pdResolveAnchor(`#${slug}`);
        if (target) {
          pdScrollToAnchor(target, slug);
          return;
        }
      }
      heroButton?.click();
    });
  });
})();
